// Lightweight WebAudio utilities for notification sounds
let audioCtx = null;

function initAudioContext() {
  if (audioCtx) return audioCtx;
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    audioCtx = AudioCtx ? new AudioCtx() : null;
  } catch (e) {
    audioCtx = null;
  }
  return audioCtx;
}

function playTone(frequency, duration = 150, type = 'sine', gain = 0.2) {
  const ctx = initAudioContext();
  if (!ctx) return;
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = type;
  o.frequency.setValueAtTime(frequency, ctx.currentTime);
  g.gain.setValueAtTime(0.0001, ctx.currentTime);
  g.gain.exponentialRampToValueAtTime(gain, ctx.currentTime + 0.01);
  o.connect(g);
  g.connect(ctx.destination);
  o.start();
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration / 1000);
  setTimeout(() => {
    try {
      o.stop();
      o.disconnect();
      g.disconnect();
    } catch (e) {}
  }, duration + 20);
}

function playSequence(tones = []) {
  let offset = 0;
  for (const t of tones) {
    setTimeout(() => playTone(t.freq, t.dur, t.type || 'sine', t.gain || 0.18), offset);
    offset += t.dur + (t.pause || 30);
  }
}

// "Cool" chime sequences
function playAccessRequestChime() {
  // moody descending minor-ish arpeggio
  playSequence([
    { freq: 880, dur: 110, type: 'sine' },
    { freq: 740, dur: 110, type: 'sine' },
    { freq: 622, dur: 140, type: 'sine' }
  ]);
}

function playAccessGrantedChime() {
  // bright ascending chime
  playSequence([
    { freq: 660, dur: 90, type: 'triangle' },
    { freq: 880, dur: 120, type: 'triangle' },
    { freq: 1100, dur: 160, type: 'sine' }
  ]);
}

function playAccessRejectedChime() {
  // single low tone
  playSequence([{ freq: 220, dur: 220, type: 'sine' }]);
}

function playPanelOpenChime() {
  playSequence([
    { freq: 880, dur: 60, type: 'sine' },
    { freq: 1200, dur: 90, type: 'triangle' }
  ]);
}

function playMarkReadChime(type) {
  if (type === 'ACCESS_GRANTED') {
    playAccessGrantedChime();
  } else {
    // subtle click
    playSequence([{ freq: 920, dur: 60, type: 'sine' }]);
  }
}

function playMarkAllChime() {
  playSequence([
    { freq: 520, dur: 90, type: 'sine' },
    { freq: 660, dur: 120, type: 'sine' }
  ]);
}

export {
  initAudioContext,
  playTone,
  playSequence,
  playAccessRequestChime,
  playAccessGrantedChime,
  playAccessRejectedChime,
  playPanelOpenChime,
  playMarkReadChime,
  playMarkAllChime
};
